import {
  findEnrollmentTermsSubstep,
  findStripePreferenceSubstep,
} from "./onboardingProgressUtil";

/**
 * Finds a dealer group row whose commonId ends with the brand code (F|L).
 * @param {Array|undefined} dealerGroup
 * @param {"F"|"L"} brandCode
 * @returns {object|null}
 */
export function findDealerGroupRowByBrand(dealerGroup, brandCode) {
  if (!Array.isArray(dealerGroup) || !brandCode) {
    return null;
  }
  return (
    dealerGroup.find((dealer) => dealer?.commonId?.endsWith(brandCode)) ?? null
  );
}

/**
 * @param {{ stripeAccountId?: string|null }|null|undefined} stripeDetails
 * @returns {boolean}
 */
export function hasStripeOnboardingDbRecord(stripeDetails) {
  return (
    stripeDetails?.stripeAccountId != null &&
    String(stripeDetails.stripeAccountId).trim() !== ""
  );
}

/**
 * @param {Array|null|undefined} progressSteps
 * @returns {boolean}
 */
export function isEnrollmentTermsCompleted(progressSteps) {
  return findEnrollmentTermsSubstep(progressSteps)?.status === "completed";
}

/**
 * Ford Stripe Setup step complete when Stripe preference substep is completed.
 * @param {Array|null|undefined} progressSteps
 * @returns {boolean}
 */
export function isStripePreferenceStepCompleted(progressSteps) {
  return findStripePreferenceSubstep(progressSteps)?.status === "completed";
}

/**
 * Lincoln dual-dealer gate: block Stripe Setup accordion until Ford Stripe Setup
 * is done. Uses onboarding DB / progress only (no Stripe Connect API).
 *
 * @param {object} params
 * @param {boolean} params.isLincolnBrand
 * @param {boolean} params.isDualDealer
 * @param {boolean} params.lincolnTermsCompleted
 * @param {boolean} params.fordTermsCompleted
 * @param {boolean} params.lincolnHasStripeRecord
 * @param {boolean} params.fordHasStripeRecord
 * @param {boolean} params.fordStripeSetupCompleted
 * @returns {boolean}
 */
export function shouldBlockLincolnStripeSetupUntilFord({
  isLincolnBrand,
  isDualDealer,
  lincolnTermsCompleted,
  fordTermsCompleted,
  lincolnHasStripeRecord,
  fordHasStripeRecord,
  fordStripeSetupCompleted,
}) {
  return (
    Boolean(isLincolnBrand) &&
    Boolean(isDualDealer) &&
    Boolean(lincolnTermsCompleted) &&
    Boolean(fordTermsCompleted) &&
    !lincolnHasStripeRecord &&
    !fordHasStripeRecord &&
    !fordStripeSetupCompleted
  );
}
